<div class="tf-sort-cntr">
    <div class="tf-sort-content">
        <ng-content></ng-content>
    </div>
    <div class="tf-sort-icons">
        <span class="tf-sort-arrow-up"
              (click)="sort()"
              [ngClass]="getClassesSortIcon(getDirection().ascending)">
    </span>
        <span class="tf-sort-arrow-down"
              (click)="sort()"
              [ngClass]="getClassesSortIcon(getDirection().descending)">
    </span>
    </div>
</div>
